export interface TagListItem {
  label: string
  value: string
}

export const mapTagToSelectItem = (tag: string): TagListItem => ({
  label: tag,
  value: tag,
})
